<div style="margin: 10px;">

	<itglue-export-config [Network]="Network" [Export]="ITGlueExport" [Agent]="Agent" [ScheduledDiscovery]="Discovery"
						[EnableExportOrigin]="true"></itglue-export-config>

</div>
